// import { Policy } from './lib/Policy';
import { Policy2 } from './lib/Policy2';

export * from './lib/components';
export * from './lib/hooks';
export default Policy2;
